module.exports = __webpack_public_path__ + "img/aviso_de_privacidad.22518092.png";